<template>
    <div class="api-configuration"  :style="{height:screenHeight + 'px'}" v-loading.fullscreen.lock="fullscreenLoading">
        <el-row style="height: 100%;" >
            <el-col :span="4" style="overflow-y:hidden;">
                <div class="grid-content menu-list" style="height: 100%">
                    <div class="border-bottom padding-bottom-5">
                        <div class="head-title" >{{$t('home.debugApi')}}</div>
                        <div class="search">
                            <el-input :placeholder="$t('home.searchWord')" prefix-icon="el-icon-search" size="small"  v-model="search"></el-input>
                        </div>
                    </div>
                    <div class="listMenu" :style="{height: (screenHeight-98) + 'px'}">
                        <el-menu v-if="menuArray" class="el-menu-vertical-demo"  router :default-active="$route.query.groupId">
                            <el-submenu v-for="(item, index) in menuArray" :key="item.id" :index="item.id.toString()" >
                                <template slot="title"><span>{{item.menuName}}</span></template>
                                <el-menu-item @click="deviceUrlClick(childMenu.id)" v-for="(childMenu ,childIndex) in item.childList" :key="childMenu.id" :index="childMenu.id.toString()"  :route="{ query: { groupId: childMenu.id.toString()} }">
                                    {{childMenu.menuName}}
                                </el-menu-item>
                            </el-submenu>
                        </el-menu>
                        <div v-if="menuArray.length === 0" class="noData">{{$t('public.noData')}}</div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6" style="overflow-y:hidden;">
                <div class="grid-content border-bottom-7" >
                    <div class="head-title">
                        <span>{{this.$store.state.listName}}</span>
                    </div>
                    <div class="debugging-button" >
                        <div style="line-height: 30px;position:absolute;left:0px">
                            <el-switch v-model="onlyRequired" @change="showRequired" style="margin-right:10px"></el-switch>
                            <span>{{$t('home.seeRequireItem')}}</span>
                        </div>
                        <div style="position: absolute;right:0px;top:0px">
                            <el-button style="width: 80px;height:28px;padding:0px 5px;" size="mini" @click="setDefaultValue">{{$t('home.fillDefaultValue')}}</el-button>
                            <el-button :style="`width: ${lang === 'en' ? '75px' : '60px'};height:28px;padding:0px 5px;`" size="mini" icon="el-icon-caret-right" type="primary"  @click="startDebug">{{$t('public.debug')}}</el-button>
                        </div>
                    </div>
                </div>
                <div class="paramsContent">
                    <div class="publicRequestParames">
                        <div class="title">{{$t('public.publicRequestParam')}}</div>
                        <el-form :model="commonParams" ref="commonParams" label-width="100px"
                            class="demo-ruleForm" :class="{'en-demo-ruleForm': lang === 'en'}">
                            <el-form-item label="method" prop="method" >
                                <el-input v-model="commonParams.method" disabled ></el-input>
                            </el-form-item>
                            <el-form-item label="appKey" prop="appKey">
                                <el-input v-model="commonParams.appKey" disabled ></el-input>
                            </el-form-item>
                            <el-form-item label="timestamp" prop="timestamp" class="tipItem">
                                <el-input v-model="commonParams.timestamp" disabled ></el-input>
                                <el-tooltip class="toolTipInfo" placement="top" effect="light">
                                    <div slot="content">{{$t('home.debugTip1')}}</div>
                                    <i class="el-icon-warning-outline"></i>
                                </el-tooltip>
                            </el-form-item>
                            <el-form-item label="version" prop="version">
                                <el-select :placeholder="$t('public.pleaseSelect')" :no-data-text="$t('public.noData')"  v-model="commonParams.version" @change="selectChanged" >
                                    <el-option v-for="item in versionList"  :key="item" :label="item" :value="item"  ></el-option>
                                </el-select>
                            </el-form-item>
                            <el-form-item label="sign" prop="sign">
                                <el-input v-model="commonParams.sign" disabled ></el-input>
                                    <el-tooltip class="toolTipInfo" placement="top" effect="light">
                                    <div slot="content">{{$t('home.debugTip2')}}</div>
                                    <i class="el-icon-warning-outline"></i>
                                </el-tooltip>
                            </el-form-item>
                        </el-form>
                    </div>
                    <div class="body">
                        <div class="title">{{$t('public.workRequestParam')}}</div>
                        <el-form  :model="ruleForm"  :rules="rules" ref="ruleForm" label-width="110px" class="demo-ruleForm" :class="{'en-demo-ruleForm': lang === 'en'}">
                            <div v-for="(formItem, index) in requestParameters" :key="formItem.name">
                                <el-form-item :label="formItem.name" :prop="formItem.name" v-show="!onlyRequired ? !onlyRequired : formItem.isRequired" >
                                    <el-select :placeholder="$t('public.pleaseSelect')"  v-if="formItem.selectType === 1" :no-data-text="$t('public.noData')" v-model="ruleForm[formItem.name]" @change="typeSelect" >
                                        <el-option v-for="item in JSON.parse(formItem.selectValue)" :key="item.value" :label="item.label" :value="item.value.toString()" ></el-option>
                                    </el-select>
                                    <el-input type="textarea"  v-else-if="formItem.name === 'writeParams'"  v-model.trim="ruleForm[formItem.name]"></el-input>
                                    <el-input v-else-if="formItem.name === 'file'" disabled v-model="fileName" :placeholder="$t('home.pleaseSelectFile')"></el-input>
                                    <!-- <el-input v-else-if="formItem.name === 'regCode' && ename === 'saveKeyApiParam'"  v-model="ruleForm[formItem.name]" ></el-input>
                                    <el-input v-else-if="formItem.name === 'iotName'&& ename === 'saveKeyApiParam' " v-model="ruleForm[formItem.name]" ></el-input>
                                    <el-input v-model="ruleForm[formItem.name]" v-else-if="formItem.name === 'connName' && ename === 'saveKeyApiParam'" :disabled="(ruleForm.regCode.indexOf(',')>0 || ruleForm.iotName.indexOf(',')>0)" ></el-input>
                                    <el-input v-else-if="formItem.name === 'collectionRules' && ename === 'saveKeyApiParam'" :disabled="(ruleForm.regCode.indexOf(',')>0 || ruleForm.iotName.indexOf(',')>0 || ruleForm.connName.indexOf(',')>0)"></el-input> -->
                                    <el-input v-model.trim="ruleForm[formItem.name]" v-else-if="formItem.name === 'connName' && ename === 'saveKeyApiParam'" ></el-input>
                                    <el-input v-model.trim="ruleForm[formItem.name]" v-else-if="formItem.name === 'collectionRules' && ename === 'saveKeyApiParam'" :disabled="ruleForm.connName.indexOf(',') > 0"></el-input>
                                    <el-input v-else v-model.trim="ruleForm[formItem.name]"></el-input>
                                    <el-tooltip  v-if="formItem.eitherOr === 1" class="deviceTipInfo" placement="top" effect="light">
                                        <div slot="content" style="font-size:14px">{{$t('home.clickChangeId')}}</div>
                                        <i v-if="formItem.eitherOr === 1" class="el-icon-refresh" @click="switchhBtn(index,formItem.name)"></i>
                                    </el-tooltip>
                                    <el-tooltip  v-if="formItem.eitherOr === 2" class="deviceTipInfo" placement="top" effect="light">
                                        <div slot="content" style="font-size:14px">{{$t('home.clickChangeName')}}</div>
                                        <i v-if="formItem.eitherOr === 2" class="el-icon-refresh"  @click="switchhBtn2(index,formItem.name)"></i>
                                    </el-tooltip>
                                    <el-tooltip  v-if="formItem.eitherOr === 3" class="deviceTipInfo" placement="top" effect="light">
                                        <div slot="content" style="font-size:14px">{{$t('home.clickChangeIot')}}</div>
                                        <i v-if="formItem.eitherOr === 3" class="el-icon-refresh" @click="switchhBtn3(index,formItem.name)"></i>
                                    </el-tooltip>
                                    <el-tooltip  v-if="formItem.eitherOr === 4" class="deviceTipInfo" placement="top" effect="light">
                                        <div slot="content" style="font-size:14px">{{$t('home.clickChangeTemplateNameOrId')}}</div>
                                        <i v-if="formItem.eitherOr === 4" class="el-icon-refresh" @click="switchhBtn4(index,formItem.name)"></i>
                                    </el-tooltip>
                                    <el-tooltip v-if="formItem.isHint === 1" class="writeParamsInfo" placement="top" effect="light">
                                        <!-- <div slot="content" style="font-size:14px" v-if="formItem.name === 'writeParams'">{{formItem.parameterRange}}</div> -->
                                        <div slot="content" style="font-size:14px" v-if="formItem.name === 'queryData'" >{{$t('home.canSelectMore')}}</div>
                                        <div slot="content" style="font-size:14px" v-else>{{formItem.parameterRange || ''}}</div>
                                        <i class="el-icon-warning-outline"></i>
                                    </el-tooltip>
                                    <el-tooltip v-if="formItem.name === 'file'" class="writeParamsInfo" placement="top" effect="light">
                                        <div slot="content" style="font-size:14px" v-if="formItem.name === 'file'">{{$t('home.pleaseSelectFile')}}</div>
                                        <el-upload
                                            :show-file-list="false"
                                            :auto-upload="false"
                                            action="https://baidu.com"
                                            :on-change="handleChange"
                                            accept=".xlsx"
                                            :multiple="false"
                                            :before-upload="beforeUpload"
                                        >
                                            <i class="el-icon-edit-outline" style="font-size:16px;position:absolute;top:0px;right:0px;"></i>
                                        </el-upload>
                                    </el-tooltip>
                                    <el-tooltip v-if="formItem.name === 'fileType'" class="writeParamsInfo" placement="top" effect="light">
                                        <div slot="content" style="font-size:14px" v-if="formItem.name === 'fileType'">{{$t('public.downLoadTemplate')}}</div>
                                        <i class="el-icon-sold-out" style="font-size:16px" @click="downloadList()"></i>
                                    </el-tooltip>
                                </el-form-item>
                            </div>
                        </el-form>
                    </div>
                </div>
            </el-col>
            <el-col :span="14">
                <div class="grid-content tabTittle" > 
                    <div>
                        <el-menu :default-active="$route.path"  class="el-menu-demo" mode="horizontal" @select="handleSelect">
                            <el-menu-item index="/debug">{{$t('public.debugResult')}}</el-menu-item>
                            <el-menu-item index="/doc">{{$t('public.doc')}}</el-menu-item>
                        </el-menu>
                    </div>
                    <div>
                        <router-view></router-view>
                    </div>
                </div>
            </el-col>
        </el-row>
    </div>
</template>
<script>
    import {mapState} from 'vuex';
    // import {handleDownloadFile} from "../common/common.js";
    export default {
        data() {
            return {
                screenHeight: document.documentElement.clientHeight,
                screenWidth: document.documentElement.clientWidth,
                search: '',
                ruleForm:{},
                versionList:[],
                commonParams: {
                    method: '',
                    appKey: '',
                    timestamp:'',
                    version:'',
                    sign: ''
                },
                nodeData: {},
                rules: {},
                onlyRequired: false,
                isRequired: false,
                menuList: [],
                menuArray: [],
                result:{},
                // propsValidObj: {},
                ename: '',
                requestParameters: [],
                requestParametersAll:[],
                switchLabel1:[],
                switchLabel0:[],
                switchLabel2:[],
                switchLabel3:[],
                switchLabel4:[],
                eitherOrIndex: 0, 
                eitherOrIndex2: 0,
                eitherOrIndex3: 0,
                eitherOrIndex4: 0,
                defaultRoute: '',
                fileName:'',
                uploadFile:'',
                newRequertArr:[],
                intType:localStorage.getItem('type'),
                fullscreenLoading:false,
                searchTimer: null,
                lang: ''
            };
        },
        mounted() {
            const that = this;
            window.onresize = () => {
                return (() => {
                    that.screenWidth = document.documentElement.clientWidth; 
                    that.screenHeight = document.documentElement.clientHeight;
                })()
            };
            this.$router.push({
                path: '/doc' ,
                query: {groupId: this.$route.query.groupId || this.defaultRoute, lang: this.$route.query.lang}
            })
        },
        computed: {
            ...mapState(['debug','isDisabled']),
        },
        watch: {
            search: function(){
                var self = this;
                this.menuArray = JSON.parse(JSON.stringify(this.menuList));
                if(!this.search) {
                    this.$router.push({path: this.$route.path, query: {groupId: this.defaultRoute}});
                    this.deviceUrlClick(this.defaultRoute);
                }else {
                    this.menuArray = this.menuArray.filter(item => {
                        if (item.menuName.toLowerCase().indexOf(this.search.toLowerCase()) !== -1) {
                            return item;
                        } else if (item.childList.some(childItem => childItem.menuName.toLowerCase().indexOf(self.search.toLowerCase()) !== -1)) {
                            item.childList = item.childList.filter(childItem => childItem.menuName.toLowerCase().indexOf(self.search.toLowerCase()) !== -1);
                            return item;
                        }
                    })  
                    if (this.menuArray && this.menuArray.length > 0) {
                        if (this.menuArray[0].childList && this.menuArray[0].childList.length > 0 && this.menuArray[0].childList[0].id) {
                            this.$router.push({path: this.$route.path, query: {groupId: this.menuArray[0].childList[0].id}});
                            this.deviceUrlClick(this.menuArray[0].childList[0].id);
                        }
                    } 
                }  
            },
            'localStorage.appKey': function(val) {
                self.$set(this.commonParams, 'appKey', val);
            },
            
            'debug': function(val) {
                this.startDebug();
            },
        },
        created() {
            this.eitherOrIndex = 0;
            this.eitherOrIndex2 = 0,
            this.eitherOrIndex3 = 0,
            this.eitherOrIndex4 = 0,
            this.getMessageData();
            this.initUrlList();
            this.setNetLogo()
            this.lang = localStorage.getItem('lang') || 'zh'
            document.title = this.$t('home.debugApi')
        },
        methods: {
            getMessageData() {
                var self = this;
                window.addEventListener("message", function(e){
                    if (e.data) {
                        if (e.data.appKey && e.data.appSecret) {
                            console.log('postMessage', e.data)
                            const lang = e.data.lang ? e.data.lang : 'zh'
                            localStorage.setItem('appKey', e.data.appKey);
                            localStorage.setItem('appSecret', e.data.appSecret);
                            localStorage.setItem('netLogoUrl', e.data.netLogoUrl);
                            clearTimeout(this.searchTimer);
                            if(self.intType !== e.data.type) {
                                self.$nextTick(() =>{
                                    self.initUrlList();           
                               })                  
                            }
                            self.$router.push({
                                query: {groupId: e.data.type === '2' ? '36' : '2', lang: lang}
                            });
                            self.intType = e.data.type;
                            localStorage.setItem('type', e.data.type);
                            localStorage.setItem('lang', lang);
                            self.$set(self.commonParams, 'appKey', localStorage.getItem('appKey') ||'');
                            self.setNetLogo()
                        }
                    }
                })
            },
            setNetLogo () {
                const url = localStorage.getItem('netLogoUrl')
                if (url) {
                    var link = document.querySelector("link[rel*='icon']") || document.createElement('link');
                    link.type = 'image/x-icon';
                    link.rel = 'shortcut icon';
                    link.href = url;
                    document.getElementsByTagName('head')[0].appendChild(link);
                }
            },
            initUrlList() {
                if(!this.intType) return
                this.setIco();
                this.fullscreenLoading = true;
                this.$store.commit('setVType', this.intType);
                var  postUrl = '';
                if(this.intType === '2') {
                    postUrl = '/rest/apiMenuGroup/getAllMenuGroupList' + '?type=' + this.intType;
                }else {
                    postUrl = '/rest/apiMenuGroup/getAllMenuGroupList';
                } 
                axios.get(postUrl,{}).then(response =>{
                    this.menuList = response.data.data;
                    this.menuArray = this.menuList;
                    this.responseHeader = response.headers;
                    this.$store.commit('setResponseHeader', this.responseHeader);
                    this.defaultRoute = this.intType === '2' ? '36' : '2';
                    this.getVersionPost(this.$route.query.groupId || this.defaultRoute);
                    this.deviceUrlClick(this.$route.query.groupId || this.defaultRoute);
                    this.searchTimer = setTimeout(() => {
                        this.fullscreenLoading = false
                    }, 1500);
                })
            },
            setIco() {
                const type = localStorage.getItem('type')
                const linkDom = document.getElementById('icoRef');
                const href = linkDom.getAttribute('href')
                if(+type === 2) {
                    href.indexOf('/32.ico') === -1 && linkDom.setAttribute('href', '/32.ico')
                }else if(+type === 1){
                   href.indexOf('/favicon.ico') === -1 && linkDom.setAttribute('href', '/favicon.ico')
                }
            },
            handleSelect(key, keyPath) {
                if (this.$route.query.groupId) {
                    this.$router.push({path: key, query:{groupId: this.$route.query.groupId}})
                } else {
                    this.$router.push({path: key})
                }
            },
            showRequired(val) {
                this.onlyRequired = val;
            },
            deviceUrlClick(id) {
                var self = this;
                //初始化调试结果页面，显示为暂无数据页
                this.$store.commit('reSetDebugResult', true);
                var postUrl = '/rest/apiMenuDetail/getMenuDetailByGroupIdAndVersion?groupId=' + id ;
                self.getVersionPost(id);
                axios.get(postUrl)
                .then(response =>{
                    var version = response.data.data.version;
                    this.ename = response.data.data.ename;
                    this.$store.commit('setEName', this.ename);
                    var data = response.data.data.requestParameters;
                    if(this.filterIotNameArr(this.ename)) {
                        data = data.filter(item => item.name !== "iotName");
                    }
                    this.requestParameters = data;
                    this.requestParametersAll = data;
                    this.switchLabel1 = [];
                    this.switchLabel2 = [];
                    this.switchLabel3 = [];
                    this.switchLabel4 = [];
                    this.switchLabel0 = [];
                    this.eitherOrIndex = 0;
                    this.eitherOrIndex2 = 0;
                    this.eitherOrIndex3 = 0;
                    this.eitherOrIndex4 = 0;
                    if(this.ename === 'batchListenRealtimeData' && version === "2.0") {
                        this.requestParameters = this.requestParameters.filter(item => {
                            return item.name !== 'callBackUrl';
                        })
                    }
                    if(version === '3.0') {
                        if(this.isSwitchDeviceId(this.ename)) {
                            this.requestParameters.forEach((item)=>{
                                if(item.eitherOr === 2) {
                                    this.switchLabel2.push(item);
                                }else if(item.eitherOr === 3){
                                    this.switchLabel3.push(item);
                                }else if(item.eitherOr === 4){
                                    this.switchLabel4.push(item);
                                }else {
                                    this.switchLabel0.push(item);
                                }
                            })
                            // if(this.switchLabel2.length  < 1 && this.switchLabel3.length  < 1) {
                            //     this.requestParameters = [...this.switchLabel0];
                            // }else if(this.switchLabel2.length  < 1) {
                            //     this.requestParameters = [this.switchLabel3[this.eitherOrIndex3],...this.switchLabel0];
                            // }else if(this.switchLabel3.length < 1) {
                            //     this.requestParameters = [this.switchLabel2[this.eitherOrIndex2],...this.switchLabel0];
                            // }else {
                            //     this.requestParameters = [this.switchLabel2[this.eitherOrIndex2],this.switchLabel3[this.eitherOrIndex3],...this.switchLabel0];
                            // }
                            this.requestParameters = [...this.switchLabel0];
                            this.switchLabel4.length > 0 && (this.requestParameters.unshift(this.switchLabel4[this.eitherOrIndex4]));
                            this.switchLabel3.length > 0 && (this.requestParameters.unshift(this.switchLabel3[this.eitherOrIndex3]));
                            this.switchLabel2.length > 0 && (this.requestParameters.unshift(this.switchLabel2[this.eitherOrIndex2]));
                            this.newRequertArr = this.requestParameters;
                        }
                        if (this.ename === 'saveKeyApiParam') {
                            this.requestParameters = this.newRequertArr.filter(item => {
                                return item.name !== 'callBackUrl';
                            })
                        }
                    }else {
                        if(this.isSwitchDeviceId(this.ename)) {
                            this.requestParameters.forEach((item)=>{
                                if(item.eitherOr === 1) { 
                                    this.switchLabel1.push(item);
                                }else{
                                    this.switchLabel0.push(item);
                                }
                            })
                            this.requestParameters = [this.switchLabel1[this.eitherOrIndex],...this.switchLabel0];
                        }
                    }
                    const {
                        requestBodySample, 
                        requestBodySample2,
                        responseBodySample, 
                        callbackurlResponseBodySample,
                        responseParameters,
                        method,
                        description,
                        name } = response.data.data
                    this.$store.commit('setFileRequestParams', data);
                    this.$store.commit('setRequestBodySample', requestBodySample);
                    this.$store.commit('setRequestBodySampleTwo', requestBodySample2);
                    this.$store.commit('setResponseBodySample', responseBodySample);
                    this.$store.commit('setCallbackurlResponseBodySample', callbackurlResponseBodySample);
                    this.$store.commit('setFileResponseParams', responseParameters);
                    this.$store.commit('setDescription', description);
                    this.$store.commit('setListName', name);
                    this.$store.commit('setVersion', version);
                    this.$store.commit('setMethod', method);  
                    this.$nextTick(() => {
                        this.$refs.ruleForm.clearValidate();
                    })
                    this.$refs.ruleForm.resetFields();
                    self.ruleForm = {};
                    self.result = {};
                    for(let v of data) {
                        self.result[v.name] = v;
                        // self.propsValidObj[v.name] = '1'; 
                        var priValidator=(rule, value, callback) => {
                            var reg = new RegExp(v.regularExpression, "g"); 
                            if(value != null && value != "") {
                                if(rule.field === "serialNo" && version === '1.0') {
                                    if( self.calcStrLenght(value) > 50) {
                                        callback(new Error(v.parameterRange));
                                    }else{
                                        callback();
                                    } 
                                }else if(rule.field === "writeParams"){
                                    if(!reg.test(value)) {
                                       callback(new Error(v.parameterRange)); 
                                    }else {
                                        if(self.isJSON(value)) {
                                            if(eval("("+value+")").length>10) {
                                                callback(new Error(self.$t('home.debugTip3')));
                                            }else {
                                                callback();
                                            }
                                        }else {
                                            callback(new Error(v.parameterRange));
                                        }
                                    }
                                }else{
                                    if(rule.field === 'file') {
                                        if(!value) {
                                            callback(new Error(v.parameterRange));
                                        }else {
                                            if(value === '1') {
                                                callback();
                                            }else {
                                                callback(new Error(v.parameterRange));
                                            }
                                        }
                                    }else {
                                        if(!reg.test(value)) {
                                            callback(new Error(v.parameterRange));
                                        } else {
                                            callback();
                                        }
                                    }
                                }
                            }else{
                                callback();
                            }
                        };
                        if (v.isRequired) {
                           self.$set(self.rules, v.name, [{required: true, trigger: 'change', message: v.parameterRange},{validator: priValidator, trigger: 'change'}]);
                        } else {
                            self.$set(self.rules, v.name, [{required: false},{validator: priValidator, trigger: ['blur', 'change']}]);
                        }
                        self.$set(self.ruleForm, v.name,'');
                    } 
                    var bodyParams = self.ruleForm;
                    this.$store.commit('setBodyParams', bodyParams);
                    this.commonParams.version = this.versionList[0];
                    this.commonParams = {
                        method: this.$store.state.method,
                        appKey: localStorage.getItem('appKey'),
                        timestamp: '',
                        version:this.commonParams.version,
                        sign:''
                    }
                    if(this.ename ===  'batchListenRealtimeData' || this.ename ===  'readRealTimeData') {
                        this.$store.commit('setIsRealTimeData', true);
                    }else {
                        this.$store.commit('setIsRealTimeData', false);
                    }
                });
                // this.$store.commit('setIsDisabled', false);
                this.$router.push({path: '/doc', query: {groupId: this.$route.query.groupId}});
                this.fileName = '';
            },
            // 切换版本时调接口
            selectChanged(value){
                var self = this;
                var postUrl = '/rest/apiMenuDetail/getMenuDetailByGroupIdAndVersion?groupId=' + this.$route.query.groupId + '&version=' + value
                axios.get(postUrl) .then(response =>{
                    var version = response.data.data.version;
                    this.ename = response.data.data.ename;
                    var data = response.data.data.requestParameters;
                    this.requestParameters = data;
                    this.switchLabel1 = [];
                    this.switchLabel0 = [];
                    this.eitherOrIndex = 0;
                    if(this.ename === 'batchListenRealtimeData' && version === "2.0") {
                        this.requestParameters = this.requestParameters.filter(item => {
                            return item.name !== 'callBackUrl';
                        })
                    }
                    if(this.isSwitchDeviceId(this.ename)) {
                        this.requestParameters.forEach((item)=>{
                            if(item.eitherOr === 1) {
                                this.switchLabel1.push(item);
                            }else{
                                this.switchLabel0.push(item);
                            }
                        })
                        this.requestParameters = [this.switchLabel1[this.eitherOrIndex],...this.switchLabel0];
                    }
                    const {
                        requestBodySample, 
                        requestBodySample2,
                        responseBodySample, 
                        callbackurlResponseBodySample,
                        responseParameters,
                        method,
                        description,
                        name } = response.data.data
                    this.$store.commit('setFileRequestParams', data);
                    this.$store.commit('setRequestBodySample', requestBodySample);
                    this.$store.commit('setRequestBodySampleTwo', requestBodySample2);
                    this.$store.commit('setResponseBodySample', responseBodySample);
                    this.$store.commit('setCallbackurlResponseBodySample', callbackurlResponseBodySample);
                    this.$store.commit('setFileResponseParams', responseParameters);
                    this.$store.commit('setDescription', description);
                    this.$store.commit('setListName', name);
                    this.$store.commit('setVersion', version);
                    this.$store.commit('setMethod', method);  
                    this.$nextTick(() => {
                        this.$refs.ruleForm.clearValidate();
                    })
                    this.$refs.ruleForm.resetFields();
                    self.ruleForm = {};
                    self.result = {};
                    for(let v of data) {
                        self.result[v.name] = v;
                        var priValidator=(rule, value, callback) => {
                            var reg = new RegExp(v.regularExpression, "g"); 
                            if(value != null && value != "") {
                                if(rule.field === "serialNo") {
                                    if( self.calcStrLenght(value) > 50) {
                                        callback(new Error(v.parameterRange));
                                    }else{
                                        callback();
                                    }  
                                }else{
                                    if(!reg.test(value)) {
                                        callback(new Error(v.parameterRange));
                                    } else {
                                        callback();
                                    }
                                }
                            }else{
                                callback();
                            }
                        };
                        if (v.isRequired) {
                           self.$set(self.rules, v.name, [{required: true, trigger: 'change', message: v.parameterRange},{validator: priValidator, trigger: 'change'}]);
                        } else {
                            self.$set(self.rules, v.name, [{required: false},{validator: priValidator, trigger: ['blur', 'change']}]);
                        }
                        self.$set(self.ruleForm, v.name,'');
                    } 
                    var bodyParams = self.ruleForm;
                    this.$store.commit('setBodyParams', bodyParams);
                    this.commonParams = {
                        method: this.$store.state.method,
                        appKey: localStorage.getItem('appKey'),
                        timestamp: '',
                        version:this.commonParams.version,
                        sign:''
                    }
                    if(this.ename ===  'batchListenRealtimeData' || this.ename ===  'readRealTimeData') {
                        this.$store.commit('setIsRealTimeData', true);
                    }else {
                        this.$store.commit('setIsRealTimeData', false);
                    }
                });
                this.$refs.ruleForm.resetFields();
                this.$router.push({path: '/doc', query: {groupId: this.$route.query.groupId}});
                this.$nextTick(() => {
                    this.$refs.ruleForm.clearValidate();
                })
            },
            // 点击子菜单获取version 
            getVersionPost(id){
                var self = this;
                var postUrl = '/rest/apiMenuDetail/getMenuDetailVersionListByGroupId?groupId=' + id
                axios.get(postUrl).then(res => {
                    this.versionList = res.data.data;
                    this.commonParams.version = this.versionList[0]; 
                })
            },
            
            calcStrLenght(str) {
                var len =0;
                str = str.toString().trim();
                for (let i =0; i <str.length; i++) {
                    var a = str.charAt(i);
                    if(a.match(/[^x00-xff]/ig) !=null) {
                        len +=2;
                    }else {
                        len +=1;
                    }
                }
                return len;
            },
            isJSON(str) {
                try {
                    const jsonObj = eval("("+str+")")
                    if ('string' === typeof str && 'object' === typeof jsonObj) return true
                } catch (error) {
                    return false
                }
                return false
            },

            switchhBtn(index,name){  
                if (this.eitherOrIndex+1 >= this.switchLabel1.length) {
                    this.eitherOrIndex = 0;
                } else {
                    this.eitherOrIndex++;
                }
                this.requestParameters = this.requestParameters.map(item =>item.eitherOr === this.switchLabel1[this.eitherOrIndex].eitherOr ? this.switchLabel1[this.eitherOrIndex] : item);
                this.$nextTick(() => {
                    // this.$refs.ruleForm.clearValidate();
                    if(name ==="serialNo" || name ==="deviceId") {
                        this.ruleForm[name]='';
                    }
                }) 
            },
            switchhBtn2(index,name) {
                if (this.eitherOrIndex2+1 >= this.switchLabel2.length) {
                    this.eitherOrIndex2 = 0;
                } else {
                    this.eitherOrIndex2++;
                }
                this.requestParameters = this.requestParameters.map(item =>item.eitherOr === this.switchLabel2[this.eitherOrIndex2].eitherOr ? this.switchLabel2[this.eitherOrIndex2] : item);
                this.$nextTick(() => {
                    if(name ==="deviceName" || name ==="serialNo") {
                        this.ruleForm[name]='';
                    }
                })
            },
            switchhBtn3(index,name) {
                if (this.eitherOrIndex3+1 >= this.switchLabel3.length) {
                    this.eitherOrIndex3 = 0;
                } else {
                    this.eitherOrIndex3++;
                }
                this.requestParameters = this.requestParameters.map(item =>item.eitherOr === this.switchLabel3[this.eitherOrIndex3].eitherOr ? this.switchLabel3[this.eitherOrIndex3] : item);
                this.$nextTick(() => {
                    if(name ==="iotName" || name ==="regCode") {
                        this.ruleForm[name]='';
                    }
                })
            },
            switchhBtn4(index,name) {
                if (this.eitherOrIndex4+1 >= this.switchLabel4.length) {
                    this.eitherOrIndex4 = 0;
                } else {
                    this.eitherOrIndex4++;
                }
                this.requestParameters = this.requestParameters.map(item =>item.eitherOr === this.switchLabel4[this.eitherOrIndex4].eitherOr ? this.switchLabel4[this.eitherOrIndex4] : item);
                this.$nextTick(() => {
                    if(name ==="templateName" || name ==="id") {
                        this.ruleForm[name]='';
                    }
                })
            },
            // 选择框切换事件
            typeSelect(selectItem) {
                if(this.ename === 'batchListenRealtimeData') {
                    if(selectItem *1 === 60) {
                        this.requestParameters = this.requestParametersAll;
                    }else if(selectItem *1 === 50){
                        this.requestParameters = this.requestParameters.filter(item => {
                            return item.name !== 'callBackUrl';
                        });
                        this.ruleForm.callBackUrl = '';
                    }
                }
                if(this.ename === 'saveKeyApiParam') {
                    let a = null;
                    this.newRequertArr.forEach(item => {
                        if(item.name === "callBackUrl") {
                            a = item;
                        }
                    })
                    if(selectItem *1 === 60 && a) {
                        this.requestParameters.push(a);
                    }else if(selectItem *1 === 50){
                        this.requestParameters = this.requestParameters.filter(item => {
                            return item.name !== 'callBackUrl';
                        });
                        this.ruleForm.callBackUrl = '';
                    }
                }
            },
            // 选择文件
            handleChange(file,fileList) {
                if (fileList && fileList.length >= 2) {
                    fileList.shift();
                }
                this.fileName = file.name;
                this.uploadFile = file;
                this.ruleForm.file = '1';
            },
            beforeUpload(file) {
                let fileAllowList = ['xlsx'];
                let typeAllow = this.inArray(file.type, fileAllowList) > -1;
                if (!typeAllow) {
                    this.$message.error(this.$t('home.supportSlsx'));
                    return false;
                }  
            },
            // 下载模板
            downloadList() {
                const gerUrl =  '/rest/exportExcelDemo?method=' + this.$store.state.method;
                axios.get(gerUrl, {
                    responseType: 'blob'
                }).then( (res) => {
                    let blob = res.data;
					let downloadFilename = this.$store.state.description + this.$t('public.template') + ".xlsx";
					if (window.navigator && window.navigator.msSaveOrOpenBlob) {
						window.navigator.msSaveOrOpenBlob(blob, downloadFilename)
					}else {
						let url = window.URL.createObjectURL(blob);
						let downloadElement = document.createElement("a");
						downloadElement.style.display = "none";
						downloadElement.href = url;
						downloadElement.download = downloadFilename;
						document.body.appendChild(downloadElement);
						downloadElement.click();
						document.body.removeChild(downloadElement);
						window.URL.revokeObjectURL(url);
					}
                })
                return
                // const successCallback = () => this.$message.success("下载成功！");
                // const failCallback = err => err && this.$message.warning(err);
                // handleDownloadFile(gerUrl, successCallback, failCallback); 
            },

            // 填写默认值
            setDefaultValue(){
                var self = this;
                Object.keys(this.result).forEach(key => {
                    if(self.result[key].example){
                       self.$set(self.ruleForm, key, self.result[key].example);
                    }
                    // 获取默认时间
                    if (this.ename === 'listHistoryEvent') {
                        if (self.result[key].name === 'startDate') {
                            self.$set(self.ruleForm, key, Common.getHistoryStartTime());
                        }
                        if (self.result[key].name === 'endDate') {
                            self.$set(self.ruleForm, key, Common.getHistoryEndTime());
                        }
                    } 
                    // 获取默认时间
                    if (this.ename === 'listDatas' || this.ename === 'listHistroys' || this.ename === 'listReminds') {
                        if (self.result[key].name === 'startTime') {
                            self.$set(self.ruleForm, key, Common.getHistoryStartTimeV3());
                        }
                        if (self.result[key].name === 'endTime') {
                            self.$set(self.ruleForm, key, Common.getHistoryEndTime());
                        }
                    } 
                    if (this.ename === 'listHistory') {
                        if (self.result[key].name === 'startTimeStr') {
                            self.$set(self.ruleForm, key, Common.getHistoryCurrentStartTime());
                        }
                        if (self.result[key].name === 'endTimeStr') {
                            self.$set(self.ruleForm, key, Common.getHistoryEndTime());
                        }
                    }
                    if (this.ename === 'batchListenRealtimeData') {
                        if(self.result[key].example === '60') {
                            this.requestParameters = this.requestParametersAll;
                        }else if (self.result[key].example === '50'){
                            this.requestParameters = this.requestParameters.filter(item => {
                                return item.name !== 'callBackUrl';
                            });
                        }
                    }
                    if(this.ename === 'saveKeyApiParam') {
                        if(self.result[key].example === '60') {
                            this.requestParameters = this.newRequertArr;
                        }else if(self.result[key].example === '50'){
                            this.requestParameters = this.newRequertArr.filter(item => {
                                return item.name !== 'callBackUrl';
                            });
                        }
                    }
                    if(self.result[key].name === 'file'){
                        if(!this.fileName) {
                            this.ruleForm.file = '';
                        }else {
                            this.ruleForm.file = '1';
                        }

                    }
                })
                
            },

            // 调试功能
            startDebug() {
                this.$refs.ruleForm.validate((valid, failObject) => {
                    if (valid) {
                        this.commonParams.timestamp = Common.getTimeStamp();
                        var newBodyParams = {};
                        var bodyParams = this.$store.state.bodyParams;
                        Object.keys(bodyParams).forEach(key => {
                            bodyParams[key] && (newBodyParams[key] = bodyParams[key])
                        })   
                        var requestBodyParams = JSON.parse(JSON.stringify(newBodyParams));
                        var newCommonParams = JSON.parse(JSON.stringify(this.commonParams)); 
                        var debugParams = Object.assign(newCommonParams, requestBodyParams);
                        debugParams.sign = this.getSign(debugParams);
                        this.commonParams.sign = debugParams.sign;
                        if(debugParams.writeParams) {
                            // debugParams.writeParams = debugParams.writeParams.replace(/[\'\"\\\/\b\f\n\r\t]/g, '');
                            debugParams.writeParams = debugParams.writeParams.replace(/[\n]/g, '');
                        }
                        if(debugParams.queryData) {
                            debugParams.queryData = debugParams.queryData.split(',');
                        }
                        this.$store.commit('setDebugParams', debugParams);
                        this.$store.commit('reSetDebugResult', false); 
                        this.getDebugResult();
                    } else {
                        let keysStr = Object.keys(failObject).join('，')
                        this.$store.commit('reSetDebugResult', true);
                        this.$message({
                            message:`${keysStr}${this.$t('home.errorFileFormat')}`,
                            duration: 2000,
                            type: 'error',
                        })
                        return false;
                    } 
                });
                this.$router.push({path: '/debug', query: {groupId: this.$route.query.groupId}});
           },
           getDebugResult() {
                var params = this.$store.state.debugParams;
                let postUrl = this.intType === '2' ? '/rest/api/v3' : '/rest/api';
                if(this.isUplodEname(this.ename)) {
                    delete params.file;
                    let formData = new FormData();
                    Object.keys(params).forEach(key => {
                        formData.append(key,params[key])
                    })
                    formData.append('file', this.uploadFile.raw)
                    postUrl = postUrl + '/file'
                    axios.post(postUrl,formData, {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        },
                    })
                    .then(response =>{
                        let result = response.data;
                        var dataCode =result.code;
                        var debugTime = response.duration;
                        this.$store.commit('setDebugResult', result);
                        this.$store.commit('setDataCode', dataCode);
                        this.$store.commit('setdebugTime', debugTime);
                    }).catch(e => {
                        this.$message.warning(this.$t('home.uploadTip1'))
                    })
                }else {
                    axios.post(postUrl, params)
                    .then(response =>{
                        let result = response.data;
                        var dataCode =result.code;
                        var debugTime = response.duration;
                        this.$store.commit('setDebugResult', result);
                        this.$store.commit('setDataCode', dataCode);
                        this.$store.commit('setdebugTime', debugTime);
                    })
                }
           },
           getSign(params) {
                var str = '';
                var appSecret = localStorage.getItem('appSecret');
                Object.keys(params).sort().forEach(function(key) {
                    if (key !== 'sign' && key !== 'writeParams' && key !== 'queryData' && key !== 'file'){
                        str += (key + params[key]);
                    }
                })
                return md5(appSecret + str + appSecret);
           },
           isSwitchDeviceId(ename) {
               var enameArr = [
                   'showDevice',
                   'listEventInfo',
                   'listHistoryEvent',
                   'listHistory',
                   'listDatas',
                   'listReminds',
                   'listDatas',
                   'listHistroys',
                   'listReminds',
                //    'getIot',
                //    'write.elementData',
                //    'read.elementData',
                //    'bindTemplate',
                //    'syncTemplate',
                   'deleteDevice',
                   'saveKeyApiParam',
                    'delIot',
                //    'recoverIot',
                   'bindIot',
                   'updateDevice',
                   'getDataSource',
                   'getDevice',
                   'getCollectionTemplate',
                ];
               return enameArr.indexOf(ename) > -1
           },
           isUplodEname(ename) {
               var enameArr = ['addIots','deleteDevices','addDevices','recoverIots'];
               return enameArr.indexOf(ename) > -1
           },
           filterIotNameArr(ename) {
                var enameArr = ['getIot','recoverIot','bindTemplate','syncTemplate','saveKeyApiParam','write.elementData','read.elementData'];
                return enameArr.indexOf(ename) > -1
           }
        }
    }
</script>

<style lang="less" scoped>
    html,
    body,
    #app {
        height: 100%;
    }
    body {
    overflow-y: hidden;
    }

    .api-configuration {
        .el-col {
            height: 100%;
            border-right: 1px solid #ccc;
        }

        .search {
            padding: 10px;

            /deep/ .el-input--small .el-input__inner {
                border-radius: 15px;
                height: 28px;
                line-height: 28px;
            }
        }

        /deep/ .el-submenu__title {
            font-size: 14px;
        }

        .border-bottom {
            border-bottom: 1px solid #E0E0E0;
            overflow: hidden;
        }

        .padding-bottom-5 {
            padding-bottom: 5px;
            background: #ffffff; 
            .head-title {
                margin: 15px 0 10px 14px;
                font-size:16px
            }
        }
        .listMenu {
            overflow-y: scroll;
        }
        .listMenu::-webkit-scrollbar {
            width: 4px;
        }
        .listMenu::-webkit-scrollbar-thumb {
            border-radius: 10px;
            -webkit-box-shadow: inset 0 0 5px rgba(0,0,0,0.2);
            background: rgba(0,0,0,0.05);
        }
        .listMenu::-webkit-scrollbar-track {
            -webkit-box-shadow: inset 0 0 5px rgba(0, 0, 0, 0.2);
            border-radius: 0;
            background: rgba(0, 0, 0, 0);
        }

        .border-bottom-7 {
            border-bottom: 1px solid #E0E0E0;
            height: 67px;
            padding-bottom: 20px;
            .debugging-button {
                font-size: 14px;
                margin: 16px 17px 0 20px;
                position: relative;
            }
            .head-title{
                padding-left: 20px;
                margin:15px 10px 0 0;
                font-size: 16px;
            }
            
        }
        .paramsContent{
            height: calc(100vh - 98px);
            overflow-y: scroll;
        }
        .paramsContent::-webkit-scrollbar {
            display: none;
        }

        .el-button.el-button--default,
        .el-button.el-button--default:hover {
            border: 1px solid #dee1e4;
            background: #ffffff;
            border-radius: 3px;
        }


        .publicRequestParames,
        .body {
            margin: 30px;
            padding: 10px;
            font-size: 14px;
            .title {
                font-weight: bold;
                margin-bottom: 20px;
                font-size: 18px;
                color: #151f28;
            }
            .content {
                padding: 0 10px;
            }
            /deep/.el-input__inner{
                margin: 10px 5px 10px 0 !important;
            }
            .custom-tree-node i {
                margin: 0 5px;
            }
         
        }
        .body {
            .deviceTipInfo {
                position: absolute;
                top:17px;right: -23px;
            }
            .deviceTipInfo:hover {
                cursor: pointer;
                color: #409EFF;
            }
            .writeParamsInfo {
                position: absolute;
                top:15px;right: -23px;
            }
            .writeParamsInfo:hover {
                cursor: pointer;
                color: #409EFF;
            }

            /deep/.el-textarea__inner {
                height: 100px;
            }
                .writeParmas{
                    border:1px solid #ddd;
                    padding:0 10px 10px 15px;
                    max-height:300px;
                    // min-height:200px;
                    overflow-y:scroll;
                    span:hover {
                        cursor: pointer;
                        color: #409EFF;
                    }
                }
                .writeParmas::-webkit-scrollbar {
                display: none;
                }
               .childsList {
                label {
                    font-size: 14px;
                    color: #606266;
                }
                .childsInput {
                    -webkit-appearance: none;
                    background-color: #FFF;
                    background-image: none;
                    border: none;
                    border-bottom: 1px solid #DCDFE6;
                    box-sizing: border-box;
                    color: #606266;
                    display: inline-block;
                    font-size: inherit;
                    height: 22px;
                    line-height: 28px;
                    outline: 0;
                    padding: 0 15px;
                    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
                    margin-left: 10px;
                    width: 50%;
                }
            }
        }
        .detail-step {
            margin-left: 15px;
        }

        .publicRequestParames,
        .body {
            .el-input {
                /deep/ .el-input__inner {
                    height: 28px;
                }
            }
            .el-select {
                display: block;
            }
            /deep/.el-input--suffix .el-input__inner {
            padding-right: 30px;
            height: 28px;
            }
        }
        .block {
            border: none;
            /deep/ .el-tree-node {
                margin: 10px 0;
            }
            .el-button {
                width: 16px;
                height:16px;
                line-height: 16px;
            }
        }
        .el-menu.el-menu--horizontal {
            padding-left: 20px;
        }
        .noData {
            width: 100%;
            height: 30px;
            color: #787878;
            margin-top: 20px;
            font-size: 14px;
            line-height: 30px;
            text-align: center;
        }
        .el-menu-demo {
            position: fixed;
            top: 0;
            z-index: 99;
            width: 100%;
            background: #fff;
        }

        .publicRequestParames {
            /deep/.el-form-item__content {
              position: relative;
            }
            .toolTipInfo{
                position: absolute;
                right: -25px;
                bottom: 13px;
            }
        } 
        .demo-ruleForm .el-form-item {
            // margin-bottom: 15px;
            margin-bottom: 5px;
            /deep/ .el-form-item__error{
                position:initial;
            }
        }
        .en-demo-ruleForm .el-form-item {
            margin-bottom: 22px;
        }
    }
</style>
